import React, {useEffect, useState} from "react";
import { NavLink, useLocation } from "react-router-dom";
import classNames from "classnames";
import HomeIcon from '@mui/icons-material/Home';
import MenuLogin from "../HeaderUser/HeaderUser";
import { BsGraphUp } from "react-icons/bs";
import { FaTableList } from "react-icons/fa6";
import { FaBars, FaMap } from "react-icons/fa";
import { VscReferences } from "react-icons/vsc";
import {sessionStore} from "../../store/sessionStore";

const SideBar = () => {
  const [toggleButton, setToggleButton] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  function handleClickCloseMenu() {
    setToggleButton(prevToggleButton => !prevToggleButton)
  }

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const toggleSideClass = classNames(
    'sidebar select-none items-center bg-white w-screen z-50', {
      'active-sidebar': toggleButton,
      'disable-sidebar': !toggleButton,
    }
  );

  return (
    <>
      <div className={toggleSideClass} id="sidebar">
        <div className="flex flex-col w-full h-full mt-12">
          <div className="flex w-full text-center items-center justify-center">
            <img src={process.env.PUBLIC_URL + "/logo.svg"}
                 alt="logo" className="w-36 h-36 mb-12"/>
          </div>

          <NavLink
            className={`flex w-full h-16 text-black border border-gray-100 px-5 items-center cursor-pointer hover:bg-gray-100 
          ${location.pathname === "/dashboard" ? "bg-[#007B4E] text-white hover:bg-green-900" : "bg-white text-black"}`}
            to="/dashboard"
            onClick={() => {
              if (isMobile) {
                handleClickCloseMenu()
              }
            }}
          >
            <HomeIcon className="mr-2"/>
            <label
              className="cursor-pointer">Dashboard</label>
          </NavLink>
          <NavLink
            className={`flex w-full h-16 text-black border border-gray-100 px-5 items-center cursor-pointer hover:bg-gray-100
          ${location.pathname === "/getting-data" ? "bg-[#007B4E] text-white hover:bg-green-900" : "bg-white text-black"} hover:bg-gray-100`}
            to="/getting-data"
            onClick={() => {
              if (isMobile) {
                handleClickCloseMenu()
              }
            }}
          >
            <BsGraphUp className="mr-2"/>
            <label className="cursor-pointer">Coleta de dados</label>
          </NavLink>
          <NavLink
            className={`flex w-full h-16 text-black border border-gray-100 px-5 items-center cursor-pointer hover:bg-gray-100
          ${location.pathname === "/reports" ? "bg-[#007B4E] text-white hover:bg-green-900" : "bg-white text-black"} hover:bg-gray-100`}
            to="/reports"
            onClick={() => {
              if (isMobile) {
                handleClickCloseMenu()
              }
            }}
          >
            <FaTableList className="mr-2"/>
            <label
              className="cursor-pointer">Relatorios</label>
          </NavLink>

          <NavLink
            className={`flex w-full h-16 text-black border border-gray-100 px-5 items-center cursor-pointer hover:bg-gray-100
          ${location.pathname === "/gaps" ? "bg-[#007B4E] text-white hover:bg-green-900" : "bg-white text-black"} hover:bg-gray-100`}
            to="/gaps"
            onClick={() => {
              if (isMobile) {
                handleClickCloseMenu()
              }
            }}
          >
            <FaMap className="mr-2"/>
            <label className="cursor-pointer">Vazios Assistenciais</label>
          </NavLink>
          <NavLink
            className={`flex w-full h-16 text-black border border-gray-100 px-5 items-center cursor-pointer hover:bg-gray-100
          ${location.pathname === "/references" ? "bg-[#007B4E] text-white hover:bg-green-900" : "bg-white text-black"} hover:bg-gray-100`}
            to="/references"
            onClick={() => {
              if (isMobile) {
                handleClickCloseMenu()
              }
            }}
          >
            <VscReferences className="mr-2" />
            <label
              className="cursor-pointer">Referências</label>
          </NavLink>

          {sessionStore.isDevUser && (
            <NavLink
              className={`flex w-full h-16 text-black border border-gray-100 px-5 items-center cursor-pointer hover:bg-gray-100
          ${location.pathname === "/logs" ? "bg-[#007B4E] text-white hover:bg-green-900" : "bg-white text-black"} hover:bg-gray-100`}
              to="/logs"
              onClick={() => {
                if (isMobile) {
                  handleClickCloseMenu()
                }
              }}
            >
              <VscReferences className="mr-2" />
              <label
                className="cursor-pointer">Logs</label>
            </NavLink>
          )}


        </div>

        <div className="flex h-24">
          <MenuLogin/>
        </div>
      </div>
      <div className="text-black p-5 cursor-pointer fixed z-50 ease-in-out flex text-2xl hover:text-gray-500"
           onClick={() => {
             handleClickCloseMenu()
           }}>
        <FaBars className="" />
      </div>
    </>
  );
};

export default SideBar;